var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isHeader)?_c('th',{staticClass:"vuetable-th-component-sequence",domProps:{"innerHTML":_vm._s(_vm.title)}}):_c('td',{staticClass:"vuetable-td-component-sequence",domProps:{"innerHTML":_vm._s(_vm.renderSequence())}})}
var staticRenderFns = []

export { render, staticRenderFns }